import theme, {
  getFontFamilyAndWeightFor,
  expandAbsolutely,
  sliceColourTheme,
  getBackgroundColour,
  getBackgroundImageWidth,
} from '../../styles/theme';

const getPadding = (backgroundColour, backgroundImage) => (backgroundColour !== sliceColourTheme.white.backgroundColour || backgroundImage ? `${theme.spacing.vertical.sm}px 20px` : '0 20px');

const getBottomMarginSize = (noBottomMargin, bottomMarginSize) => {
  if (noBottomMargin) return 0;
  return bottomMarginSize === 'Large' ? '3rem' : '0.75rem';
};

export default {
  wrapper: {
    position: 'relative',
    backgroundColor: ({
      colourTheme: { backgroundColour }, backgroundImage,
    }) => getBackgroundColour(backgroundColour, backgroundImage),
    padding: ({ colourTheme: { backgroundColour }, backgroundImage }) => getPadding(backgroundColour, backgroundImage),
    marginBottom: ({ noBottomMargin, bottomMarginSize }) => getBottomMarginSize(noBottomMargin, bottomMarginSize),
  },
  backgroundImage: {
    ...expandAbsolutely,
    maxWidth: ({ backgroundImageWidth }) => getBackgroundImageWidth(backgroundImageWidth),
  },
  container: {
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: 0,
    maxWidth: 1280,
    color: ({ colourTheme: { textColour } }) => textColour,
    '& .right-align': {
      textAlign: 'right',
      display: 'block',
    },
    '& .center-align': {
      textAlign: 'center',
      display: 'block',
    },
    '& $textContainer p': {
      fontSize: '16px',
      lineHeight: 1.5,
      color: 'inherit',
      fontFamily: theme.fonts.body,
    },
    '& h1, h2, h3, h4': {
      margin: '0 0 16px 0',
      ...getFontFamilyAndWeightFor('body'),
      color: 'inherit',
      fontWeight: 'bold',
      letterSpacing: '0.3px',
    },
    '& h1': {
      fontSize: '28px',
      lineHeight: 1.5,
    },
    '& h2': {
      fontSize: '24px',
      lineHeight: 1.5,
    },
    '& h3': {
      fontSize: '20px',
      lineHeight: 1.5,
    },
    '& h4': {
      fontSize: '16px',
      lineHeight: 1.5,
    },
    '&::after': {
      content: '""',
      clear: 'both',
      display: 'table',
    },
  },
  small: {
    maxWidth: 768,
  },
  textContainer: {
    columnGap: 16,
    [theme.breakpoints.up('md')]: {
      columns: ({ columns }) => `150px ${columns}`,
    },
    '& p a:not(.button)[href]': {
      color: ({ colourTheme: { textColour } }) => textColour,
      textDecoration: 'underline',
    },
    '& p a:not(.button)[href]:hover, p a:not(.button)[href]:focus': {
      color: ({ colourTheme: { linkHover } }) => linkHover,
      textUnderlinePosition: 'initial',
    },
  },
  ctaContainer: {
    marginTop: 24,
    display: 'block',
    fontSize: '16px',
    '&.left': {
      textAlign: 'left',
    },
    '&.right': {
      textAlign: 'right',
    },
    '&.center': {
      textAlign: 'center',
    },
  },
};
